import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Shown instead of any portal data when the API answers 403 EDUCATION_PORTAL_CUSTODY_RESTRICTED.
 * Deliberately generic: it never names the restriction, its reason, or the court note.
 */
export default function PortalCustodyRestrictedAlert() {
  const { t } = useTranslation('education');
  return (
    <Alert
      type="error"
      showIcon
      data-testid="portal-custody-restricted"
      message={t('portalCustodyRestrictedTitle', { defaultValue: 'Portal access restricted' })}
      description={t('portalCustodyRestrictedBody', {
        defaultValue: 'Portal access to this student is restricted. Please contact the school office.',
      })}
    />
  );
}
